module.exports = __webpack_public_path__ + "img/h5-item-1.c90a7c38.png";